import { xBaseTheme } from "@eisinc/XDL/types";

import colors from "@eisinc/XDL/PreStyle/colors";
import { BaseTheme, ThemeColor, ThemeColors } from "@insite/mobius/globals/baseTheme";
import ToastPresentationPropsDefault, {
    toasterProps as toasterPropsDefault,
} from "@insite/mobius/Toast/presentationProps";
import { get } from "@insite/mobius/utilities";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { css, ThemeProps } from "styled-components";

const iconColor = get(colors, "common.ui1");

export default {
    defaultProps: {
        ...ToastPresentationPropsDefault,
        cssOverrides: {
            toast: css`
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                border-left-width: 5px;
            `,
            toastBody: css`
                margin: 12px 16px 12px 20px !important;
            `,
        },
        iconProps: {
            css: css`
                display: none;
            `,
        },
        bodyTypographyProps: {},
        closeButtonProps: {
            color: "transparent",
            css: css`
                &:hover {
                    background-color: transparent;
                }

                padding-left: 5px;
                padding-right: 5px;
                margin-right: 2px;
                margin-top: 8px;
            `,
        },
        closeButtonIconProps: {
            color: iconColor,
            css: css`
                width: 20px;
                height: 20px;
            `,
        },
        iconSrcByMessage: {},
    },
    toasterProps: { toasterPropsDefault },
} as xBaseTheme["toast"];
